export class GoogleMapsConfig {
  public key: string;
}
